/**
 *
 * HeaderLayout
 *
 */

import React, { memo, useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link, useHistory, useLocation } from "react-router-dom";

// styles
import "./style.scss";

// antd component
import { Button, Layout, Space, Tooltip } from "antd";
const { Header } = Layout;

// assets
import CustomIcons from "components/CustomIcons";
import { useTranslation } from "react-i18next";


// components
import { SchoolDropdown } from "components/School";
import LanguageSelector from "components/LanguageSelector";

// context
import { useLogout } from "engine/Contexts/User.context";
// helper
import _local from "utils/localStorageUtils";
import UserAvatar from "components/UserAvatar";
import { withUser } from "engine/Contexts/User.context";
import { getEnviromentLabel } from 'utils/helpers/helper.generateData';

function HeaderLayout({
  notifications,
  // actions
  notificationsAction,
  // default props
  className,
  user,
  ...rest
}) {
  const localUser = _local.getLocalData("schoolinked_user");
  const childClassNames = classNames(
    "layout-header",
    localUser?.role,
    className,
  );
  const envLabel = useMemo(() => getEnviromentLabel(), []);
  const logOut = useLogout();
  const { t } = useTranslation();

  const [currentUser, setCurrentUser] = useState(false);

  useEffect(() => {
    if (user?._id || localUser?._id) {
      setCurrentUser(!!user?._id ? user : localUser);
    }
    return () => {
      setCurrentUser(false);
    }
  }, [user?._id, localUser?._id]);


  return (
    <Header className={childClassNames} {...rest}>
      <div className="header-logo">
        <Link className="header-logo__link" to="/home">
          {localUser?.role == "teacher" ? (
            <CustomIcons className="header-logo__image" type="logo-white" />
          ) : (
            <CustomIcons className="header-logo__image" type="logo" />
          )}
          {envLabel}
        </Link>
        <SchoolDropdown className="header-logo__description" />
        {/* INFO: enable ability to change language based on custom list of languages */}
        <LanguageSelector />
      </div>

      <Space
        size={"middle"}
        style={{ justifyContent: "flex-end", width: "100%" }}
      >
        <Link to={`/utilisateurs/${currentUser?._id}`}>
          <Space>
            <UserAvatar
              user={currentUser}
              width={26}
              height={26}
              fontSize={10}
            />
            {!!currentUser?.name
              ? currentUser?.name
              : (
                currentUser?.description?.firstname && `${currentUser?.description?.firstname} ${
                  currentUser?.description?.lastname
                }`
              )}
          </Space>
        </Link>
        <Tooltip placement="bottom" title={t("layouts.header.logout")}>
          <Button
            type={"text"}
            className="logout-bar"
            onClick={logOut}
            style={{ marginLeft: "15px" }}
          >
            <CustomIcons type={"logout"} />
          </Button>
        </Tooltip>
      </Space>
    </Header>
  );
}

HeaderLayout.propTypes = {
  notificationsAction: PropTypes.func.isRequired,
};

export default memo(withUser(HeaderLayout));
